import * as Yup from 'yup';
import validaCpf from '../../../../utils/validaCpf';
import validaCnpj from '../../../../utils/validaCnpj';
import validaEmail from '../../../../utils/validaEmail';

export function criarSchema(cpf_cnpj_proibido: string): Yup.ObjectSchema<any> {
  return Yup.object().shape({
    grupo_cliente_id: Yup.string().required('O grupo de clientes é obrigatório'),
    pessoa: Yup.object().shape({
      nome: Yup.string().when('juridica', (juridica: boolean, schem) => {
        return juridica
          ? schem
              .required('A razão social é obrigatória')
              .min(5, 'A razão social deve ter pelo menos 5 caracteres')
              .max(100, 'A razão social não deve ter mais de 100 caracteres')
          : schem
              .required('O nome é obrigatório')
              .min(5, 'O nome deve ter pelo menos 5 caracteres')
              .max(100, 'O nome não deve ter mais de 100 caracteres');
      }),
      apelido: Yup.string().when('juridica', (juridica: boolean, schem) => {
        return juridica
          ? schem
              .required('O nome fantasia é obrigatório')
              .min(3, 'O nome fantasia deve ter pelo menos 3 caracteres')
              .max(100, 'O nome fantasia não deve ter mais de 100 caracteres')
          : schem
              .required('O apelido é obrigatório')
              .min(3, 'O apelido deve ter pelo menos 3 caracteres')
              .max(100, 'O apelido não deve ter mais de 100 caracteres');
      }),
      cpf_cnpj: Yup.string()
        .transform(value => value.toUpperCase().replace(/[^A-Z0-9]/g, ''))
        .when('juridica', {
          is: true,
          then: Yup.string()
            .test('Cnpj', 'Cnpj inválido', value => validaCnpj(value || ''))
            .test('Cnpj', 'Já existe um cliente cadastrado com esse cnpj.', value => {
              return value !== '' && value !== cpf_cnpj_proibido;
            }),
        })
        .when('juridica', {
          is: false,
          then: Yup.string()
            .test('Cpf', 'Cpf inválido', value => validaCpf(value || ''))
            .test('Cpf', 'Já existe um cliente cadastrado com esse cpf.', value => {
              return !!value && value !== cpf_cnpj_proibido;
            }),
        }),
      rg_insc: Yup.string().max(
        20,
        'A inscrição estadual não deve ter mais de 20 caracteres',
      ),
      endereco: Yup.object().shape({
        cep: Yup.string()
          .transform(value => value.replace(/[^0-9]/g, ''))
          .required('O cep é obrigatório')
          .length(8, 'O Cep deve possuir 8 dígitos'),
        logradouro: Yup.string().max(
          80,
          'O logradouro não deve ter mais de 80 caracteres',
        ),
        bairro: Yup.string().max(
          50,
          'O bairro não deve ter mais de 50 caracteres',
        ),
        numero: Yup.string().max(
          15,
          'O número não deve ter mais de 15 caracteres',
        ),
        complemento: Yup.string().max(
          50,
          'O complemento não deve ter mais de 50 caracteres',
        ),
        cidade: Yup.string().required('A cidade é obrigatória'),
        estado: Yup.string().required('A UF é obrigatória'),
      }),
      contato: Yup.object().shape({
        email: Yup.string().test(
          'Email',
          'Digite um e-mail válido',
          value => !value || validaEmail(value),
        ),
        outros: Yup.string().max(100),
      }),
    }),
  });
}
